export const filterRangeValues = {
  monthlyRate: {
    minValue: 200,
    maxValue: 2000,
    step: 100
  },
  financingPeriod: {
    minValue: 12,
    maxValue: 60,
    step: 6
  },
  advance: {
    minValue: 1000,
    maxValue: 20000,
    step: 100
  }
};

export const EUR_CURRENCY = 'EUR';

export const defaultPager = {
  page: 1,
  pageSize: 8,
  totalCount: 10
};

export const initialPartner = {
  partnerType: '',
  generalData: {
    uniqueId: '',
    firstName: '',
    lastName: '',
    partnerName: '',
    relationId: ''
  },
  contactData: {
    personName: '',
    email: '',
    phone: ''
  },
  agreesWithPersonalDataUse: false
};

export const initialSteps = [
  {
    id: 0,
    code: 'ASSET_SELECTION',
    title: 'Simulator.Step.AssetSelection',
    route: `/simulator/assetSelection`,
    completed: false,
    disabled: false,
    error: false,
    visible: () => {
      return true;
    }
  },
  {
    id: 1,
    code: 'OFFER',
    title: 'Simulator.Step.Offer',
    route: `/simulator/offer`,
    completed: false,
    disabled: true,
    error: false,
    visible: () => {
      return true;
    }
  }
];

export const stepCodes = {
  ASSET_SELECTION: 'ASSET_SELECTION',
  OFFER: 'OFFER'
};

export const initialFilters = {
  monthlyRate: [400, 1000],
  financingPeriod: 60,
  advance: 4000,
  isSortDescending: true,
  assetTypeId: ''
};
